// extracted by mini-css-extract-plugin
module.exports = {"container":"TabelasIntegracao_container__2t7gS","toolBar":"TabelasIntegracao_toolBar__2hZqS","columnAction":"TabelasIntegracao_columnAction__tTxSs"};